import PropTypes from 'prop-types';
import UILink from 'UIComponents/link/UILink';

// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'cust... Remove this comment to see the full error message
import SkeletonText from 'customer-data-reference-ui-components/name/SkeletonText';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'cust... Remove this comment to see the full error message
import UnknownName from 'customer-data-reference-ui-components/name/UnknownName';

// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'refe... Remove this comment to see the full error message
import * as ReferenceTypes from 'reference-resolvers/schema/ReferenceTypes';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'refe... Remove this comment to see the full error message
import ResolveReferences from 'reference-resolvers/ResolveReferences';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'refe... Remove this comment to see the full error message
import { isLoading, isResolved } from 'reference-resolvers/utils';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'refe... Remove this comment to see the full error message
import { FORM } from 'reference-resolvers/constants/ReferenceObjectTypes';
import { jsx as _jsx } from "react/jsx-runtime";
const propTypes = {
  href: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  // input mapResolversToProps
  form: ReferenceTypes.byId // output mapResolversToProps
};
const FormNameView = ({
  href,
  form
}) => {
  if (isResolved(form) && !form.isEmpty()) {
    if (href) {
      return /*#__PURE__*/_jsx(UILink, {
        external: true,
        href: href,
        children: form.get('label')
      });
    }
    return /*#__PURE__*/_jsx("span", {
      children: form.get('label')
    });
  } else if (isLoading) {
    return /*#__PURE__*/_jsx(SkeletonText, {});
  }
  return /*#__PURE__*/_jsx(UnknownName, {
    referenceObjectType: FORM
  });
};
const mapResolversToProps = (resolvers, {
  id
}) => ({
  form: resolvers[FORM].byId(id)
});
const FormName = ResolveReferences(mapResolversToProps)(FormNameView);
FormNameView.propTypes = propTypes;
export default FormName;